module.exports = __webpack_public_path__ + "img/drug-cat-single.29daf55e.png";